"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userListStyles = void 0;
const userListStyles = ({ palette }) => ({
    wrapper: {
        display: 'flex',
        minWidth: 500,
        gap: 16,
        alignItems: 'center',
    },
    nameWrapper: {
        lineHeight: 1,
        textTransform: 'capitalize',
    },
    rightBlock: {
        marginLeft: 'auto',
    },
    textTertiary: {
        color: palette.text.tertiary,
    },
    chip: {
        borderRadius: 8,
        background: palette.state.disabled.surface,
    },
    managerBlock: {
        marginRight: 50,
    },
    labelsWrapper: {
        maxWidth: 430,
    },
    textEllipsis: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
});
exports.userListStyles = userListStyles;
